import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import InfoView from 'components/InfoView';
import '../styles/root.css'
import IntlMessages from 'util/IntlMessages';

class InaktivaUser extends Component {
   
    render() {
        return (
            <div className="d-flex justify-content-center align-items-center w-100 bg">
                <div className="app-login-container animated slideInUpTiny animation-duration-3">
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="Notyfile">
                                <img src={require("assets/images/logo.png")} alt="Notyfile" title="Notyfile"/>
                            </Link>
                        </div>
                        <div className="app-login-content">
                            <div className="app-login-header mb-4">
                                <h1><IntlMessages id="Account.Disabled" />
                                </h1>
                            </div> 
                            <div className="app-login-form">
                                {
                                <form> 
                                   <fieldset>
                                   <IntlMessages id="Account.Disabled.Message" /> <a href="emailto:support@notyfile.se">support@notyfile.se</a>
                                   </fieldset>
                                </form>
                                }
                            </div>
                        </div>
                    </div>
                    <InfoView/>
                </div>
            </div>
        );
    }
}

export default InaktivaUser;